<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" label-width="80px" @submit.native.prevent>
            <el-form-item label-width="0" prop="name">
                <el-input v-model.trim="searchForm.name" maxlength="20" placeholder="请输入索引名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('academic:divide:divideList:add')" type="primary" size="small"
                           icon="el-icon-plus" @click="addColumn(0)">新增
                </el-button>
                <el-button v-if="hasPermission('academic:divide:divideList:deleteColumn')" type="danger" size="small"
                           icon="el-icon-delete" @click="deleteColumn()">批量删除
                </el-button>
            </el-form-item>
        </el-form>
        <div class="dataBox">
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" border
                    ref="multipleTable"
                    :row-key="'id'"
                    @selection-change="selectionChangeHandle"
            >
                <el-table-column :reserve-selection="true" type="selection" width="50"/>
                <el-table-column prop="indexName" label="索引名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="indexType" label="所属类型" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <div>{{ row.indexType == '0' ? '标签' : row.indexType == '1' ? '分组' : '专题' }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="indexSort" label="排序" show-overflow-tooltip></el-table-column>
                <el-table-column prop="indexState" label="显示状态" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-switch
                                v-model="row.indexState"
                                active-value="1"
                                @change="setType(row)"
                                inactive-value="0">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="{row}">
                        <el-button v-if="hasPermission('academic:divide:divideList:edit')" type="text" size="small"
                                   @click="addColumn(2,row)">编辑
                        </el-button>
                        <el-button v-if="hasPermission('academic:divide:divideList:deleteColumn')" type="text"
                                   size="small" @click="deleteColumn(row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <add-divide ref="addDivide" @refresh="refreshList(1,1)"></add-divide>
    </div>
</template>

<script>

import AddDivide from "@/views/modules/academic/divide/addDivide.vue";

export default {
    name: "divideList",
    components: {AddDivide},
    data() {
        return {
            searchForm: {
                name: '',
                current: 1,
                size: 20,
            },
            total: 0,

            loading: false,
            dataList: [],
            dataListSelect: [],
        }
    },

    mounted() {
        this.refreshList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            this.loading = true
            this.$axios(this.api.academic.categoricalindexList, this.searchForm).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        //切换状态
        setType(row) {
            row.indexState = row.indexState == 1 ? 0 : 1 //
            this.$axios(this.api.academic.categoricalindexUpdateById, {
                id:row.id,
                indexState: row.indexState == 1 ? 0 : 1,
            }, 'put').then(data => {
                if (data && data.status) {
                    this.$message.success('修改成功')
                    this.refreshList('', 1)
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //0新增/2编辑按钮
        addColumn(num, row) {
            this.$refs.addDivide.init(row)
        },

        //删除
        deleteColumn(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let statusTrueList = []
            let ids = list.map(item => {
                if (item.indexState == 1){
                    statusTrueList.push(item)
                }
                return item.id
            })
            if (statusTrueList.length != 0) {
                this.$message.warning('请先禁用后再删除！')
                return
            }
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.categoricalindexRemoveById, {ids}, 'delete').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },


    },
}
</script>

<style scoped>

</style>
